import { Copy } from '../types/copy';
import { OpCo } from '../types/type';
import { afiCopy, msaCopy, polarisHomeSiteCopy } from './index';

export default function getCopyById(opcoId: string, partnerId: ''): Copy {
  let copyFileName = '';
  switch (opcoId) {
    case OpCo.AMFAM:
      copyFileName = 'afiCopy';
      break;
    case OpCo.MSA:
      copyFileName = 'msaCopy';
      break;
    case OpCo.HOMESITE:
      copyFileName = 'polarisHomeSiteCopy';
      break;
    default:
      break;
  }
  // Opcos without their own copy file (e.g. third-party or agent opcos) fall back to AFI copy
  return themeMap[copyFileName] ?? afiCopy;
}

const themeMap: { [key: string]: Copy } = {
  msaCopy,
  afiCopy,
  polarisHomeSiteCopy,
};
